<template>
    <div id="details" :class="['m-row', Classes().detailsPosition]" :style="`width: ${Width()};`">
        <div id="details-copy" :class="[Classes().detailsCopyBackground, Classes().detailsState]" :style="`border-bottom: ${Styles().detailsCopyBorder};`">

            <!-- Details toggle -->
            <div class="btn toggle" @click="Toggle()" v-if="displayType.landscape">
                <img class="block" src="@/assets/Images/ArrowUp.png" alt="Arrow - Up" title="Arrow - Up" width="20" height="10" v-if="show"/>
            </div>

            <div id="details-copy-items" v-show="show">
                <Name :name="project.Name" :theme="theme"/>
                <ClientYear
                    v-if="project.YearRange"
                    :theme="theme"
                    :clients="project.Clients"
                    :yearRange="project.YearRange"
                />
                <Description :theme="theme" :description="Description()"/>
            </div>

            <!-- Details toggle -->
            <div class="btn flex-center toggle" v-if="!show && displayType.landscape" @click="Toggle()">
                <img class="block" src="@/assets/Images/ArrowDown.png" alt="Arrow - Down" title="Arrow - Down" width="20" height="10"/>
            </div>

        </div>
    </div>
</template>

<script>
import Name from "@/components/Projects/Project/Name.vue";
import ClientYear from "@/components/Projects/Project/ClientYear.vue";
import Description from "@/components/Projects/Project/Description.vue";
import { CONFIG } from "@/assets/JS/Config.js";
import { Animation } from "@/assets/JS/Animation.js";
import $ from "jquery";

export default {
    name: "FeatureDetails",
    props: {
        project: Object,
        mediaDisplayType: String,
        theme: Object,
        position: String,
        timelineProjectMapID: Number
    },
    components: {
        Name,
        ClientYear,
        Description
    },
    data: () => ({
        displayType: {
            landscape: false,
            isolated: false
        },
        show: true
    }),
    methods: {
        Classes: function() {
            const { landscape, isolated } = this.displayType;
            let detailsCopyBackground = "";
            if (landscape) {
                detailsCopyBackground = "details-copy-background";
            }
            if (isolated) {
                detailsCopyBackground = "details-copy-no-background";
            }
            return {
                detailsCopyBackground,
                detailsPosition: `details-${this.position.toLowerCase()}`,
                detailsState: !this.show ? "details-copy-hidden flex-center" : ""
            };
        },
        Styles: function() {
            const { landscape, isolated } = this.displayType;
            let detailsCopyBorder = "";
            if (landscape) {
                detailsCopyBorder = `5px solid ${this.theme.primary}`;
            }
            if (isolated) {
                detailsCopyBorder = "none";
            }
            return { detailsCopyBorder };
        },
        Toggle: function() {
            this.show = !this.show;
            new Animation(
                $("#details-copy-items"),
                "Fade",
                this.show ? 1 : 0,
                750,
                0
            );
        },
        Width: function() {
            if (this.displayType.landscape) {
                return `${this.show ? CONFIG.projects.detailsWidth : 0}%`;
            }
            return 100;
        },
        Description: function() {
            const { ProjectDetail } = this.project;
            if (ProjectDetail) {
                const description = ProjectDetail.find(pd => pd.TimelineProjectMapID === this.timelineProjectMapID);
                return description.Description;
            }
        }
    },
    beforeMount: function() {
        this.displayType = {
            landscape: this.mediaDisplayType === "Landscape",
            isolated: this.mediaDisplayType === "Isolated"
        };
    }
};
</script>